<ngx-traffic-bar-chart
  [data]="trafficBarData.data"
  [labels]="trafficBarData.labels"
  [formatter]="trafficBarData.formatter"
></ngx-traffic-bar-chart>
